<!-- Main Content area -->
<div *ngIf="!hideScreen" id="fb-forecast-new-planner" class="container-fluid">
  <div class="btn-wrapper" [hidden]="!isShowTreeDropDowns">
    <div class="form-group">
      <app-treeview-dropdown
        [type]="'Channel'"
        [items]="channelDropdownList"
        (valueChange)="setValue($event)"
      >
      </app-treeview-dropdown>
    </div>
    <div class="form-group">
      <app-treeview-dropdown
        [type]="'Item'"
        [items]="productList"
        (valueChange)="setValue($event)"
      >
      </app-treeview-dropdown>
    </div>
    <div class="form-group">
      <app-treeview-dropdown
        [type]="'Timeframe'"
        [items]="calendarListDropdown"
        (valueChange)="setValue($event)"
      >
      </app-treeview-dropdown>
    </div>
    <div class="form-group" *ngIf="showVersionList">
      <mat-form-field>
        <mat-label>Choose Version</mat-label>
        <mat-select>
          <mat-option
            *ngFor="let version of versionList"
            [value]="version.versionTypeId"
            >{{ version.versionTypeName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button
        (click)="mapGridList(false)"
        [disabled]="
          !isDeleted ||
          itemIds.length == 0 ||
          channelIds.length == 0 ||
          calendarIds.length == 0
        "
        class="btn btn-primary adjust-btn"
      >
        Build
      </button>
    </div>
  </div>
  <div [hidden]="!gridMapped">
    <mat-accordion class="fb-forecast-accordion">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header
          collapsedHeight="35px"
          expandedHeight="35px"
        >
          <mat-panel-title> Data Manager </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          class="container-fluid item-wrapper fb-forecast-planner"
          [style.height]="isAnyOpened() ? '70vh' : ''"
        >
          <div class="row method-planner-bottom">
            <div class="col-md-4 fb-line align">
              <div>
                <h3>View Data Set</h3>
                <form>
                  <div class="form-group">
                    <label>Product</label>
                    <app-treeview-dropdown
                      [type]="'Item'"
                      [isReadonly]="true"
                      [items]="restoredProductList"
                      style="z-index: 1"
                      (valueChange)="setRestoredValue($event)"
                    >
                    </app-treeview-dropdown>
                  </div>
                  <div class="form-group">
                    <label>Timeframe</label>
                    <app-treeview-dropdown
                      [type]="'Timeframe'"
                      [isReadonly]="true"
                      [items]="restoreCalendarList"
                      (valueChange)="setRestoredValue($event)"
                    >
                    </app-treeview-dropdown>
                  </div>
                  <div class="form-group">
                    <label>Channel</label>
                    <app-treeview-dropdown
                      [isReadonly]="true"
                      [type]="'Channel'"
                      [items]="restoredChannelList"
                      (valueChange)="setRestoredValue($event)"
                    >
                    </app-treeview-dropdown>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-md-4 fb-line align">
              <div>
                <h3>Refresh Measures</h3>
                <form>
                  <div class="form-group">
                    <label>Select Measure</label>
                    <mat-select
                      placeholder=""
                      (selectionChange)="onSelectionChanged($event)"
                      [multiple]="true"
                      [disableOptionCentering]="true"
                    >
                      <mat-option
                        *ngFor="let item of refreshMeasuresList"
                        [value]="item.measureId"
                        >{{ item.measureName }}
                      </mat-option>
                    </mat-select>
                  </div>
                </form>
              </div>
              <div class="row">
                <div class="col-12 btn-wrapper">
                  <button
                    class="btn btn-primary m-0"
                    (click)="refreshMeasure()"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div>
                <h3>Forecast Update</h3>
                <form>
                  <div class="form-group">
                    <label>Forecast Measure</label>
                    <mat-select [(ngModel)]="selectedForecastMeasure">
                      <mat-option
                        *ngFor="let item of udpfcstList"
                        [value]="item"
                        >{{ item.measureName }}</mat-option
                      >
                    </mat-select>
                  </div>
                  <div class="form-group">
                    <label>UDP Forecast</label>
                    <mat-select [(ngModel)]="selectedUDPMeasure">
                      <mat-option
                        *ngFor="let item of udpMeasuresList"
                        [value]="item"
                        >{{ item.measureName }}</mat-option
                      >
                    </mat-select>
                  </div>
                  <div class="form-group">
                    <label>Adjustment %</label>
                    <input type="text" [(ngModel)]="adjustment" />
                  </div>
                  <div class="form-group">
                    <label>Timeframe</label>
                    <app-treeview-dropdown
                      [type]="'TimeframeWithWeeksUDP'"
                      [items]="timeFrameListWithWeeksUPD"
                      (valueChange)="setDataManagerValues($event)"
                    >
                    </app-treeview-dropdown>
                  </div>
                </form>
              </div>
              <div class="row">
                <div class="col-md-12 btn-wrapper">
                  <button class="btn btn-primary m-0" (click)="applyUDP()">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <app-global-demand-planner-grid-new
      [yearListGrid]="yearListGrid"
      *ngIf="yearListGrid.length > 0"
      [viewPermission]="viewPermission"
      [editPermission]="editPermission"
      [account]="account"
      [product]="product"
      [leftGroupList]="leftGroupList"
      [measureList]="measureList"
      [dropdownObjects]="dropdownObjects"
      [forecastList]="forecastList"
      [versionTypeId]="versionTypeId"
      [calendarList]="timeframeList"
      [selectedProducts]="productTree"
      [selectedChannel]="channelTree"
      [productTree]="productTree"
      (onClickEvent)="save()"
      [itemsList]="itemsList"
      [accountList]="accountList"
      (updateGridList)="updateCriteria($event)"
      [fbForecastSelectedId]="fbForecast?.fbForecastSelectedId"
      [forecastMethod]="forecastMethod"
      [seasonalitySourceLevel]="seasonalitySourceLevel"
      [movingAverageWeeks]="movingAverageWeeks"
      [calendarIds]="calendarIds"
      [userFBForecastId]="userFBForecastId"
      [fbForecast]="fbForecast"
      [isRestoreSession]="isRestoreSession"
      [isOpenSaved]="isOpenSaved"
      [guid]="data.guid"
      [measureKeys]="measureKeys"
      [masterMeasureList]="masterMeasureList"
    >
    </app-global-demand-planner-grid-new>
  </div>
</div>
<ng-template #saveForecast>
  <h1 mat-dialog-title>What would you like to name your planner?</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Enter Planner Name"
        [(ngModel)]="plannerName"
        [ngModelOptions]="{ standalone: true }"
      />
    </mat-form-field>
  </div>
  <div class="action-panel text-right btn-wrapper">
    <button
      mat-raised-button
      class="btn btn-primary m-left"
      color="primary"
      (click)="ref.close()"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      class="btn btn-primary m-left"
      color="warn"
      (click)="ref.close(true)"
    >
      Save
    </button>
  </div>
</ng-template>
<ng-template #commitForecast>
  <div mat-dialog-content>
    <p>Are you sure you want to commit your changes?</p>
  </div>
  <div class="action-panel text-right btn-wrapper">
    <button
      mat-raised-button
      class="btn btn-primary m-left"
      color="primary"
      (click)="ref.close()"
    >
      No
    </button>
    <button
      mat-raised-button
      class="btn btn-primary m-left"
      color="warn"
      (click)="commitFacebookPlanner()"
    >
      Yes
    </button>
  </div>
</ng-template>
